import gql from 'graphql-tag';

export const templatesQuery = gql`
  query Templates($folderId: String, $offset: Int, $limit: Int, $search: String) {
    templates(folderId: $folderId, offset: $offset, limit: $limit, search: $search) {
      totalCount
      documents {
        id
        name
        type
        externalEditorType
        createdAt
        previewThumbUrl
        pages {
          id
        }
      }
    }
  }
`;
